<template>
  <div
      class="crypto-icon"
      :style="{
        'width': size? size + 'px': null,
        'height': size? size + 'px': null,
      }"
      :class="{ 'mob-plain': mobPlain, 'plain': plain }"
  >
    <img
        v-if="iconName"
        :src="iconPath"
        :style="{
          'width': size? size + 'px': null,
          'height': size? size + 'px': null,
        }"
        loading="lazy"
    />
  </div>
</template>

<script>
import { getPaybisIconsUrl } from '@/helpers/cdnHelper';

export default {
  name: 'CryptoIcon',

  props: {
    iconName: { type: String, required: false },
    size: { type: Number, required: false, default: null },
    mobPlain: { type: Boolean, required: false, default: false },
    plain: { type: Boolean, required: false, default: false },
  },

  computed: {
    iconPath () {
      return getPaybisIconsUrl(`/default/crypto-icons/${this.iconName.toUpperCase()}.svg`);
    },
  },
};
</script>

<style lang="scss">
.crypto-icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: rem(40);
  height: rem(40);
  border-radius: 50%;
  background-color: $grey-04;
  vertical-align: middle;

  &.plain {
    background-color: transparent;
  }

  & img,
  &.plain {
    width: rem(16);
    height: rem(16);
  }

  @media screen and (min-width: $screen-lg-min) {
    & img {
      display: block;
      width: rem(20);
      height: rem(20);
    }
  }

  @media screen and (max-width: $screen-md-max) {
    &.mob-plain {
      width: rem(16);
      height: rem(16);
      background-color: transparent;
    }
  }
}
</style>
